import { useStableCallback } from "@bezoned/shared/hooks/use-stable-callback.js";
import { routes } from "@bezoned/shared/routes.js";
import { Body2 } from "@fluentui/react-components";
import { useLocation, useNavigate } from "react-router-dom";

import { useTenant } from "./tenant.context.js";

export const TenantPermissionUpgradeBanner = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const tenant = useTenant();
  const handleClick = useStableCallback(() =>
    navigate({
      pathname: routes.protected.permissionUpgrade,
      search: location.search,
    })
  );

  if (tenant.type === "enterprise" || !tenant.permissions.needsUpgrade) {
    return null;
  }

  return (
    <div className="w-full overflow-hidden bg-sky-100 py-1">
      <div className="mx-auto flex w-full items-center justify-center gap-4 px-4 py-2 text-sm md:w-3/5">
        <Body2>
          BeZoned permissions were updated. Please ask your organization
          administrator to review and approve the new configuration. Until then,
          some parts of BeZoned may not work properly.
        </Body2>

        <button
          className="shrink-0 rounded bg-sky-700 px-3 py-1 text-sm font-medium whitespace-nowrap text-white transition-colors hover:bg-sky-800"
          onClick={handleClick}
          type="button"
        >
          Grant permissions
        </button>
      </div>
    </div>
  );
};
